import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import store from "./Redux/store";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then(function (registration) {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch(function (error) {
      console.error("Service Worker registration failed:", error);
    });
}

const loadGoogleMaps = (callback) => {
  if (window.google && window.google.maps) {
    callback();
    return;
  }

  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}&libraries=places&libraries=geometry`;
  script.async = true;
  script.defer = true;
  script.onload = () => {
    console.log("✅ Google Maps API loaded successfully");
    callback();
  };
  script.onerror = () => {
    console.error("❌ Failed to load Google Maps API");
  };
  document.head.appendChild(script);
};

const RootApp = () => {
  useEffect(() => {
    loadGoogleMaps(() => {
      window.googleMapsLoaded = true;
      console.log("🎉 Google Maps ready to use!");
    });
  }, []);

  return (
    <BrowserRouter>
      <Provider store={store}>
        <App />
      </Provider>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootApp />);
